import React, { ReactChildren } from "react"
import { Link } from "gatsby";
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import SharpImage from '../utils/sharpImage';
import PersonIcon from '@material-ui/icons/Person';
import { useTheme } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
    infoBoxContainer: {
        //height: "280px",
        //backgroundColor: theme.palette.primary.darkest,
        //color: theme.palette.text.primary,
        height: "100%",
    },
    infoBoxImgContainer: {
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
    },
    infoBoxImgContainerSml: {
        width: "100%",
        height: "200px",
    },
    infoBoxImgContainerMd: {
        width: "100%",
        height: "250px",
    },
    infoBoxImgContainerLg: {
        width: "100%",
        height: "300px",
    },
    infoBoxImg: {
        width: "100%",
        height: "100%",
        display: "flex",
    },
    textAlignLeft: {
        textAlign: "left",
    },
    textAlignCenter: {
        textAlign: "center",
    },
    textAlignRight: {
        textAlign: "right",
    },
    infoBoxTitle: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    infoBoxContent: {
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },
    link: {
        color: '#fff',
        textDecoration: "none",
    }
}));

interface Props {
    title: string;
    image: string;
    size: string;
    children?: ReactChildren;
    link?: string;
    textAlign?: string;
    images: Array<any>;
    color?: string;
    pages: Array<any>;
}

const InfoBox = ({ title, image, children, size, link, textAlign, images, color, pages }: Props) => {
    const classes = styles();

    let asset = null;
    if (image && images)
        asset = images.filter(x => x.assetId === image)[0];

    if (size !== "sml" && size !== "md" && size !== "lg")
        size = "md"; //Default to md

    if (textAlign !== "left" && textAlign !== "center" && textAlign !== "right")
        textAlign = "left"; //Default to left

    const theme = useTheme();

    const getBackground = () => {
        if (color === "darkest")
            return theme.palette.primary.darkest;
        else if (color === "dark")
            return theme.palette.primary.dark;
        else if (color === "main")
            return theme.palette.primary.main;
        else if (color === "light")
            return theme.palette.primary.light;
        else if (color === "lightest")
            return theme.palette.primary.lightest;
        else
            return theme.palette.background.paper
    }


    const WrapLink = ({ children }) => {
        const linkedPage = pages.find((x: { itemId: string }) => x.itemId == link);

        if (linkedPage)
            return (
                <Link to={linkedPage.slug.raw} className={classes.link}>
                    {children}
                </Link>
            );
        else {
            console.warn(`Page not found. Page id: ${link}`);
        }

        return <>{children}</>
    }

    return (
        <div className={classes.infoBoxContainer} style={{backgroundColor: getBackground(), color: theme.palette.getContrastText(getBackground()) }}>
            <WrapLink>
                <div className={`${classes.infoBoxImgContainer} ${size === "sml" ? classes.infoBoxImgContainerSml : ""} ${size === "md" ? classes.infoBoxImgContainerMd : ""} ${size === "lg" ? classes.infoBoxImgContainerLg : ""}`}>
                {/*TODO: load image from ICE*/}
                    {asset && asset.localFile ?
                        <div className={classes.infoBoxImg}><SharpImage file={asset.localFile} title={asset.fileName} altText={asset.fileName} /></div>
                        : <PersonIcon style={{ width: "100%", height: "100%" }} />}
                </div>
                <div className={`${textAlign === "left" ? classes.textAlignLeft : ""} ${textAlign === "center" ? classes.textAlignCenter : ""} ${textAlign === "right" ? classes.textAlignRight : ""}`}>
                    <div className={classes.infoBoxTitle}>
                        <Typography variant="h5">{title}</Typography>
                    </div>
                    {children &&
                        <div className={classes.infoBoxContent}>
                            {children}
                        </div>
                    }
                </div>
            </WrapLink>
        </div>
        )
}

InfoBox.NAME = "InfoBox";
export default InfoBox
